<template>
  <li>
    <div>{{ name }}</div>
    <div>{{ size }}</div>
    <div>{{ done }}</div>
  </li>
</template>
<script>
export default {
  name: "MemSumItem",
  props: ["name", "size", "done"],
};
</script>